export default "__VITE_ASSET__fd092961__"